'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _specialties = require('./specialties.component');

var _specialties2 = _interopRequireDefault(_specialties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var specialtiesModule = _angular2.default.module('specialties', [_angularUiRouter2.default]).component('specialties', _specialties2.default);

exports.default = specialtiesModule;


// WEBPACK FOOTER //
// ./client/app/common/admin/specialties/specialties.js